import { DataBean } from "../DataBean";

export class Report extends DataBean {
  public async getReports(reportType: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getReports_Number",
      [reportType]
    );
  }

  public async getAvailableFilters(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAvailableFilters_Number",
      [arg]
    );
  }

  public async getAvailableParsers(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAvailableParsers_Number",
      [arg]
    );
  }

  public async getDataTransferRecordForDataParser(
    classForName: string
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "String_getDataTransferRecordForDataParser_String",
      [classForName]
    );
  }

  public async deleteReport(idReport: number): Promise<any> {
    return this.getCustomService("OrangeCore", "void_deleteReport_Number", [
      idReport,
    ]);
  }

  public async updateReport(bean: string): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "reports.Report_updateReport_reports.Report",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "reports.Report",
        },
      ]
    );
  }

  public async migrateReports(args: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "boolean_migrateReports_Number",
      [args]
    );
  }
}
